<template>
  <CRow>
    <CCol col="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Users
          <CButton size="sm" style="float:right;" color="success" @click="addUserModal = true">Add User</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            table-filter
          >
          <template #status="{item}">
            <td>
              <CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
            </td>
          </template>
          <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="showUser( item.id )">Show</CButton>
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="editUser( item.id )">Edit</CButton>
            </td>
          </template>
          <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add User"
        :show.sync="addUserModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            label="Name"
            :value.sync="$v.addUserForm.name.$model"
            :isValid="checkIfValid('name')"
            placeholder="Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />

          <CInput
            type="email"
            label="Email"
            :lazy="false"
            :value.sync="$v.addUserForm.email.$model"
            :isValid="checkIfValid('email')"
            placeholder="Email"
            autocomplete="email"
            invalidFeedback="This is a required field and must be valid e-mail address"
          />

          <div>
            <label>User Type</label>
            <v-select 
              v-model="$v.addUserForm.user_type.$model"
              :options="['csr', 'rep', 'admin', 'admin_assistant']" 
              :isValid="checkIfValid('user_type')"
              placeholder="User Type"
            />
          </div>

          <div style="margin-top:15px;">
            <label>Menu Role(s)</label>
            <v-select 
              v-if="roles"
              multiple
              v-model="$v.addUserForm.menu_roles.$model"
              :options="roles" 
              :isValid="checkIfValid('menu_roles')"
              placeholder="Menu Roles"
            />
          </div>

          <div style="margin-top:15px;">
            <label>Distributor?</label>
            <div>
              <CButton size="sm" @click="$v.addUserForm.distributor.$model = 1" :color="addUserForm.distributor === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="$v.addUserForm.distributor.$model = 0" style="margin-left:5px;" :color="addUserForm.distributor === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>

          <CInput type="text" style="margin-top:15px;" label="CSR Code (if any)" id="csr_code" placeholder="CSR Code" v-model="addUserForm.csr_code"></CInput>

          <CInput type="text" style="margin-top:15px;" label="Rep # (if any)" id="rep_num" placeholder="Rep #" v-model="addUserForm.rep_number"></CInput>

          <div style="margin-top:15px;">
            <label>Timezone</label>
            <v-select
              v-model="$v.addUserForm.timezone.$model"
              :options="['CST', 'EST', 'PST']"
              placeholder="Timezone"
            />
          </div>
          <div style="margin-top:15px;">
            <label>Send Email?</label>
            <select class="form-control" v-model="addUserForm.send_email">
              <option value="1">Yes, send them email</option>
              <option value="0">No, do not send</option>
            </select>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="addUserModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="addUser()" color="success">Add</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import { validationMixin } from "vuelidate"
import 'vue-select/dist/vue-select.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"

export default {
  name: 'Users',
  data() {
    return {
      items: [],
      fields: ['id', 'name', 'email', 'registered', 'roles', 'status', 'show', 'edit', 'delete'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      roles: null,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addUserModal: false,
      addUserForm: this.getUserForm(),
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  mixins: [validationMixin],
  validations: {
    addUserForm: {
      name: {
        required
      },
      email: {
        required
      },
      user_type: {
        required
      },
      menu_roles: {
        required
      },
      rep_number: {
        required,
        email
      },
      timezone: {
        required
      },
      distributor: {

      }
    }
  },
  computed: {
    formString () { return JSON.stringify(this.addUserForm, null, 4) },
    isValid () { return !this.$v.addUserForm.$invalid },
    isDirty () { return this.$v.addUserForm.$anyDirty },
  },
  methods: {
    addUser() {
        let self = this;
        axios.post(   this.$apiAdress + '/api/register',
          self.addUserForm
        )
        .then(function (response) {
            console.log(response)
            self.addUserModal = false
            self.addUserForm = self.getForm()
            self.items.push(response.data)
        }).catch(function (error) {
            // if(error.response.data.message == 'The given data was invalid.'){
            //   self.message = '';
            //   for (let key in error.response.data.errors) {
            //     if (error.response.data.errors.hasOwnProperty(key)) {
            //       self.message += error.response.data.errors[key][0] + '  ';
            //     }
            //   }
            //   self.showAlert();
            // }
        });
    },
    getRoles() {
      axios.get(this.$apiAdress + '/api/roles?token=' + localStorage.getItem('api_token')).then(response => {
        console.log(response)
        // this.roles = response.data
        var that = this
        this.roles = []
        response.data.forEach(function (val) {
          that.roles.push(val.name)
        })
      })
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getUserForm () {
      return {
        name: "",
        email: "",
        user_type: "",
        rep_number: "",
        menu_roles: [],
        timezone: 'CST',
        send_email: 0,
        rep_number: '',
        csr_code: '',
        distributor: 0
      }
    },
    validate () {
      this.$v.$touch()
    },
    checkIfValid (fieldName) {
      const field = this.$v.addUserForm[fieldName]
      if (!field.$dirty) {
        return null
      } 
      return !(field.$invalid || field.$model === '')
    },

    reset () {
      this.addUserForm = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    userLink (id) {
      return `users/${id.toString()}`
    },
    editLink (id) {
      return `users/${id.toString()}/edit`
    },
    showUser ( id ) {
      const userLink = this.userLink( id );
      this.$router.push({path: userLink});
    },
    editUser ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteUser ( id ) {
      let self = this;
      let userId = id;
      axios.post( this.$apiAdress + '/api/users/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'DELETE'
      })
      .then(function (response) {
          self.message = 'Successfully deleted user.';
          self.showAlert();
          self.getUsers();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getUsers (){
      let self = this;
      axios.get( this.$apiAdress + '/api/users?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.users;
        self.you = response.data.you;
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getUsers();
    this.getRoles()
  }
}
</script>
